var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.80423 1.68444C3.804 2.12734 3.62785 2.552 3.31452 2.86502C3.00119 3.17804 2.57635 3.35376 2.13346 3.35354C1.69056 3.35332 1.26589 3.17717 0.952878 2.86384C0.639861 2.55051 0.464134 2.12567 0.464356 1.68277C0.464577 1.23988 0.640729 0.815211 0.954059 0.502194C1.26739 0.189177 1.69223 0.0134506 2.13513 0.0136721C2.57802 0.0138935 3.00269 0.190045 3.3157 0.503375C3.62872 0.816705 3.80445 1.24155 3.80423 1.68444ZM3.85432 4.59013H0.514454V15.0439H3.85432V4.59013ZM9.13132 4.59013H5.80815V15.0439H9.09792V9.55818C9.09792 6.5022 13.0807 6.21832 13.0807 9.55818V15.0439H16.3788V8.42263C16.3788 3.27088 10.484 3.46292 9.09792 5.99287L9.13132 4.59013Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer-linkedin.d577074e3493dc68f1d785827e3b23f7.svg";
export { ForwardRef as ReactComponent };